function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUdns(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M12 1.995A10.005 10.005 0 0122.005 12c0 5.526-4.48 10.005-10.005 10.005-5.526 0-10.005-4.48-10.005-10.005C1.995 6.474 6.475 1.995 12 1.995zm5.657 4.348c-1.52-1.52-3.489-.79-5.656.93-2.169-1.72-4.138-2.45-5.657-.93-1.52 1.52-.79 3.489.93 5.656-1.72 2.169-2.45 4.138-.93 5.658 1.519 1.52 3.488.79 5.656-.93 2.169 1.72 4.138 2.45 5.657.93 1.52-1.52.79-3.49-.93-5.657 1.72-2.168 2.45-4.137.93-5.657zm-2.264 7.187c1.093 1.433 1.284 2.279.85 2.713-.434.434-1.282.24-2.71-.85.31-.295.625-.601.942-.918l.198-.2c.197-.198.389-.396.576-.593zm-6.785 0c.294.313.6.628.918.945l.199.198c.25.247.498.488.745.72-1.43 1.089-2.279 1.284-2.713.85-.423-.423-.248-1.24.77-2.606zm3.39-3.617c.194.18.395.37.602.572l.461.454.426.432c.212.218.412.427.6.63-.18.19-.37.391-.572.599l-.454.46A39.63 39.63 0 0112 14.086a37.904 37.904 0 01-.6-.57l-.461-.454c-.376-.376-.717-.73-1.025-1.062.178-.192.369-.391.57-.599l.454-.46.432-.427c.16-.155.315-.304.466-.446zm-4.24-2.156c.434-.434 1.282-.24 2.711.85l-.15.144-.198.189-.397.387-.397.397c-.247.25-.487.499-.72.746-1.089-1.43-1.283-2.279-.85-2.713zm5.868.777c1.375-1.028 2.193-1.2 2.617-.777.433.434.24 1.282-.85 2.71l-.332-.346-.388-.397-.397-.397c-.25-.247-.498-.488-.745-.72z"
  }));
}

SvgUdns.clsName = 'icon-www__udns';
SvgUdns.remarkName = 'unknown';
export default SvgUdns;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Udns.js
// module id = 2466
// module chunks = 17 18